import BillingSettings from '@/pages/settings/billing'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/settings/billing',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <BillingSettings />
  )
}
